<template>
  <div class="share-banner">
    <div class="container">
      <p class="lead shared-by"><span class="material-icons-round" aria-hidden="true">visibility</span>You are viewing a {{ contentTypeLabel }} <template v-if="userName"> shared by <b>{{ userName }}</b></template></p>
      <div class="flex-container">
        <div class="input-group">
          <span class="input-group-btn">
            <CopyButton
              @copied="shareLinkCopied"
              :copy-text="shareLink"
              success-text="Link copied"
              btn-class="btn-primary btn-sm">
              <i class="fa fa-link" aria-hidden="true"/> Copy Link
            </CopyButton>
          </span>
          <input
            aria-label="Share Link"
            :value="shareLink"
            type="text"
            :size="shareLink.length"
            class="input-sm form-control"
            readonly>
        </div>
        <span class="last-updated"><b>Last Updated:</b>&nbsp;{{ formattedLastUpdated }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import CopyButton from '@/components/CopyButton'
export default {
  name: 'SharedPageBanner',
  components: { CopyButton },
  props: {
    studentName: {
      type: String,
      required: true
    },
    userName: {
      type: String,
      required: true
    },
    shareLink: {
      type: String,
      required: true
    },
    lastUpdated: {
      type: String,
      required: true
    },
    contentTypeLabel: {
      type: String,
      required: true
    },
    contentType: {
      type: String,
      required: true
    }
  },
  computed: {
    formattedLastUpdated() {
      return moment(this.lastUpdated).format('M/D/YY h:m A')
    }
  },
  methods: {
    shareLinkCopied() {
      this.$sendEvent('Copied Share Link', {
        share_content_type: this.contentType
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';

.shared-by {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 400;
}
.material-icons-round {
  margin-right: 4px;
  vertical-align: middle;
}
.share-banner {
  padding: 15px;
  background-color: @libraryColorBg;
  margin-bottom: 10px;
  margin-top: -20px;
}
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.input-group {
  margin-right: 12px;
  input.form-control {
    max-width: 500px;
    background: #FFFFFF;
    color: var(--gray-weak);
    height: 39px;
    font-size: 14px;
  }
}
.last-updated {
  padding: 4px 0;
  font-size: 12px;
}

::v-deep .btn-primary {
  background-color: @gb_blue_medium;
  padding: 8px 16px;
  font-size: 14px;
}
</style>
